import { render } from "./personal-loan-thankyou.vue?vue&type=template&id=f9974978&scoped=true"
import script from "./personal-loan-thankyou.vue?vue&type=script&lang=js"
export * from "./personal-loan-thankyou.vue?vue&type=script&lang=js"

import "./personal-loan-thankyou.vue?vue&type=style&index=0&id=f9974978&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9974978"]])

export default __exports__